import UpdateInventoryGroupContent from "../../content/inventoryGroup/updateInventoryGroup";
import { Layout } from "../../layout/page";

export function UpdateInventoryGroup() {
  return (
    <Layout>
      <UpdateInventoryGroupContent />
    </Layout>
  );
}
